module.exports = __webpack_public_path__ + "static/media/01.e7fcf097.jpg";